(function () {
  'use strict';

  var metrics = { lcp: null, cls: 0, inp: null };
  var reported = false;

  function rating(name, value) {
    if (name === 'lcp') return value <= 2500 ? 'good' : value <= 4000 ? 'needs-improvement' : 'poor';
    if (name === 'cls') return value <= 0.1 ? 'good' : value <= 0.25 ? 'needs-improvement' : 'poor';
    if (name === 'inp') return value <= 200 ? 'good' : value <= 500 ? 'needs-improvement' : 'poor';
    return 'unknown';
  }

  function publish() {
    if (reported) return;
    reported = true;
    var detail = {
      event: 'mood_web_vitals',
      page_type: window.MOOD_PAGE_CONTEXT && window.MOOD_PAGE_CONTEXT.pageType || null,
      page_handle: window.MOOD_PAGE_CONTEXT && window.MOOD_PAGE_CONTEXT.handle || null,
      lcp_ms: metrics.lcp == null ? null : Math.round(metrics.lcp),
      lcp_rating: metrics.lcp == null ? null : rating('lcp', metrics.lcp),
      cls: Math.round(metrics.cls * 1000) / 1000,
      cls_rating: rating('cls', metrics.cls),
      inp_ms: metrics.inp == null ? null : Math.round(metrics.inp),
      inp_rating: metrics.inp == null ? null : rating('inp', metrics.inp)
    };
    window.MOOD_WEB_VITALS = detail;
    window.dispatchEvent(new CustomEvent('mood:web-vitals', { detail: detail }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
  }

  if (!('PerformanceObserver' in window)) return;
  try {
    new PerformanceObserver(function (list) {
      var entries = list.getEntries();
      if (entries.length) metrics.lcp = entries[entries.length - 1].startTime;
    }).observe({ type: 'largest-contentful-paint', buffered: true });
  } catch (error) {}

  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (!entry.hadRecentInput) metrics.cls += entry.value;
      });
    }).observe({ type: 'layout-shift', buffered: true });
  } catch (error) {}

  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (entry.interactionId && (metrics.inp == null || entry.duration > metrics.inp)) metrics.inp = entry.duration;
      });
    }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
  } catch (error) {}

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') publish();
  });
  window.addEventListener('pagehide', publish, { once: true });
})();
